import React, { useEffect, useState } from 'react';
import '../styles/contact.css'; 

const Contact = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/918000047833?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/918000047833?text=${encodedMessage}`;

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    position: '',
    date: '',
    link: '',
  });

  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { firstName, lastName, email, phone, position, date, link } = formData;

    try {
      let formDataToSend = new FormData();
      formDataToSend.append('firstName', firstName);
      formDataToSend.append('lastName', lastName);
      formDataToSend.append('email', email);
      formDataToSend.append('phone', phone);
      formDataToSend.append('position', position);
      formDataToSend.append('date', date);
      formDataToSend.append('link', link);

      const response = await fetch(
        'https://script.google.com/macros/s/AKfycbzZSbtGJbwEQY4d0KlcppHFE0oM3k6ec2sHpXSR1_CmIeg8vc6CMTgGkIEA8aTnWOSf/exec',
        {
          method: 'POST',
          body: formDataToSend,
        }
      );

      if (!response.ok) {
        throw new Error(`Error: ${response.statusText}`);
      }

      setSuccess(true);

      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        position: '',
        date: '',
        link: '',
      });

      setTimeout(() => {
        setSuccess(false);
      }, 2000);
    } catch (error) {
      console.error(error.message);
      setError(error.message);
    }
  };

  return (
    <div className="contact-page">
      {/* Top Content Section */}
      <div className="contact-top">
        <h1><span className="highlight">Get In</span> Touch</h1>
        <p>
          Have a question, partnership inquiry, or need assistance? Our Mahadev Book team is here to guide you. We ensure a smooth, secure, and supportive environment for all our users.
        </p>
        <div className="contact-info">
          <p><strong>Customer Care:</strong><br />
            Direct WhatsApp Line: <a href={whatsappLink}>+91 8888568888</a>
          </p>
        </div>
        <div className="support-details">
          <p>Reach out to us for:</p>
          <ul>
            <li><strong>Cricket ID Registration:</strong> Get instant access and start playing within minutes.</li>
            <li><strong>Account Setup:</strong> Help with registration, logins, or settings.</li>
            <li><strong>Technical Issues:</strong> Facing bugs or payment errors? We’re here to resolve them.</li>
            <li><strong>Collaborations:</strong> Interested in joining the Mahadev network? Let’s talk!</li>
            <li><strong>Feedback & Suggestions:</strong> Share your thoughts to help us improve.</li>
          </ul>
          <p>
            We believe in prompt support and transparent communication. Contact us now and elevate your Mahadev Book experience.
          </p>
        </div>
      </div>

      {/* Bottom Form Section */}
      <div className="contact-bottom">
        <h2>Drop Us a Line</h2>
        <form className="contact-form" onSubmit={handleSubmit}>
          <div className="input-group">
            <input
              type="text"
              name="firstName"
              placeholder="First Name *"
              value={formData.firstName}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last Name *"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="email"
              name="email"
              placeholder="Email *"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone *"
              value={formData.phone}
              onChange={handleChange}
              required
            />
          </div>
          <div className="input-group">
            <input
              type="text"
              name="position"
              placeholder="Position / Interest *"
              value={formData.position}
              onChange={handleChange}
              required
            />
            <input
              type="date"
              name="date"
              value={formData.date}
              onChange={handleChange}
            />
          </div>
          <div className="input-group full-width">
            <input
              type="url"
              name="link"
              placeholder="LinkedIn / Website URL *"
              value={formData.link}
              onChange={handleChange}
              required
            />
          </div>
          <button type="submit" className="apply-button">Send Message</button>
        </form>
        {success && <p className="success-message">Thanks! We’ll get back to you soon.</p>}
        {error && <p className="error-message">{error}</p>}
      </div>
      <div className="contactpage-buttons">
        <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
          Get Your Demo ID
        </a>
        <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
          Message Us Now
        </a>
      </div>
    </div>
  );
};

export default Contact;
